import React, { useState, useEffect } from 'react'
import {useSearchParams} from 'react-router-dom'
import { registrationConfirmation } from '../util/axios_utils';
import '../App.css';
import { Typography } from 'antd';

const ConfirmEmail = () => {
    const [searchParams] = useSearchParams();
    const [isConfirm, setIsConfirm] = useState(false);
    // const [isresendConfirm, setIsresendConfirm] = useState(false);
    useEffect(() => {
        const token = searchParams.get('token');
        // const token1 = searchParams.get('token');
        // console.log("Get data1==>", searchParams.get('token'));
        if (token) {
            registrationConfirmation(token)
                .then(response => {
                    setIsConfirm(true);
                }).catch(error => {
                    setIsConfirm(false);
                    // resendRegistrationToken(token)
                    //     .then(response => {
                    //         setIsresendConfirm(true);
                    //     }).catch(error => {
                    //         setIsresendConfirm(true);
                    //     });
                });
        }
    }, [searchParams]);


    return (
        <div>
            {isConfirm ? (
                <Typography.Title level={3} className="App-body"> Учетная запись подтверждена. Можете <a href="/login">войти</a> в Личный кабинет.</Typography.Title>
            ) : (
                <Typography.Title level={3} className="App-body">Извините. Подтверждение регистрации просрочено. Вам направлено новое письмо с подтверждением.</Typography.Title>
            )}
        </div>
    )

}
export default ConfirmEmail;